import { IBadgeOption } from '../../interface/Badge'

export const defaultBadgeOption: Readonly<Required<IBadgeOption>> = {
  top: 0,
  left: 5
}
